import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

const initialState = {
  loading: false,
  uploadBillsData: {},
  error: "",
  success: false,
  status: "",
};

const uploadBillsCall = createAsyncThunk("post/uploadBills", async (data) => {
  try {
    const result = await axios.post(
      'https://apac-apigateway.capillarytech.com/mobile/v2/api/transactions/image',
      data
    );
  
    return result?.data;
  } catch (err) {
    console.log(err);
  }
});

const uploadBillsSlice = createSlice({
  name: "upload-bills",
  initialState,
  reducers: {
    reset: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(uploadBillsCall.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(uploadBillsCall.fulfilled, (state, action) => {
  
      state.loading = false;
      state.uploadBillsData = action.payload;
      // state.success = action.payload?.status.success === "true" ? true : false;
      state.error = "";
    });
    builder.addCase(uploadBillsCall.rejected, (state, action) => {
      state.loading = false;
      state.uploadBillsData = {};
      state.error = action.error.message;
      state.success = false;
    });
  },
});

export default uploadBillsSlice.reducer;
export const { reset } = uploadBillsSlice.actions;
export { uploadBillsCall };
